/*
  Mothers' Garden – szállítási díjak előre, a kosárban (2026-10)
  Kosárfiók: „C” design (szállítás + becsült végösszeg, „Szállítási módok és árak” alsó panel).
  Kosároldal: „B” design (díjak a csomagpont-választó soraiban; tartalék: önálló díjlista).
  A díjak, a küszöb és a szállítási idő a snippets/mg-shipping-rates.liquid fájlban állíthatók.
*/
(function () {
  if (window.MgShipRates) return;

  var MG_CONFIG = window.MgShipConfig;
  if (!MG_CONFIG || !MG_CONFIG.methods) return;
  window.MgShipRates = true;

  var state = { total: null, count: 0, pending: null };
  var isCartPage = /(^|\s)template-cart(\s|$)/.test(document.body.className);

  function money(cents) {
    try {
      if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
        return theme.Currency.formatMoney(cents, MG_CONFIG.moneyFormat);
      }
    } catch (e) {}
    return Math.round(cents / 100).toLocaleString('hu-HU') + ' Ft';
  }
  function codText() {
    return 'Utánvét esetén +' + money(MG_CONFIG.cod) + '.';
  }
  function from(cents) {
    return money(cents) + '-tól';
  }
  function escapeHtml(text) {
    return String(text).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function isFree() {
    return state.total !== null && state.total >= MG_CONFIG.threshold;
  }
  function cheapest(type) {
    var min = null;
    MG_CONFIG.methods.forEach(function (m) {
      if (type && m.type !== type) return;
      if (min === null || m.price < min) min = m.price;
    });
    return min || 0;
  }
  function methodsOf(type) {
    return MG_CONFIG.methods.filter(function (m) { return m.type === type; });
  }
  function sorted() {
    return MG_CONFIG.methods.slice().sort(function (a, b) { return a.price - b.price; });
  }

  var ICONS = {
    truck: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M2 7h11v9H2zM13 10h4l3 3v3h-7"/><circle cx="6" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>',
    point: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/></svg>',
    home: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3 11l9-7 9 7v9H3z"/><path d="M10 20v-5h4v5"/></svg>',
    chevron: '<svg width="14" height="14" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true" focusable="false"><path d="M4.5 2.5L8 6l-3.5 3.5"/></svg>',
    close: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true" focusable="false"><path d="M3 3l10 10M13 3L3 13"/></svg>'
  };

  /* ---------- Kosár adatai ---------- */
  function fetchCart() {
    if (state.pending) return state.pending;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    state.pending = fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        state.total = cart.total_price;
        state.count = cart.item_count;
        state.pending = null;
        return cart;
      })
      .catch(function () {
        state.pending = null;
      });
    return state.pending;
  }

  /* ---------- Kosárfiók („C”) ---------- */
  function drawerHtml() {
    var free = isFree();
    var cheap = cheapest();
    var rows = sorted().map(function (m) {
      var price = free
        ? '<span class="mg-ship__free">Ingyenes</span>'
        : '<span class="mg-ship-sheet__amount">' + money(m.price) + '</span><span class="mg-ship-sheet__sum">összesen ' + money(state.total + m.price) + '</span>';
      return '<li class="mg-ship-sheet__item">' + ICONS[m.type] +
        '<span class="mg-ship-sheet__name">' + escapeHtml(m.name) +
        '<span class="mg-ship-sheet__eta">Érkezés: ' + MG_CONFIG.eta + '</span></span>' +
        '<span class="mg-ship-sheet__price">' + price + '</span></li>';
    }).join('');
    var missing = MG_CONFIG.threshold - state.total;
    var foot = free
      ? codText() + ' ' + money(MG_CONFIG.threshold) + ' felett a szállítás ingyenes.'
      : codText() + ' ' + money(MG_CONFIG.threshold) + ' felett mindegyik ingyenes – ehhez még ' + money(missing) + ' hiányzik.';

    return '' +
      '<div class="mg-ship__row"><span>Szállítás</span>' +
        (free ? '<span class="mg-ship__val mg-ship__free">Ingyenes</span>' : '<span class="mg-ship__val">' + from(cheap) + '</span>') +
      '</div>' +
      '<div class="mg-ship__row mg-ship__row--total"><span>' + (free ? 'Végösszeg' : 'Becsült végösszeg') + '</span>' +
        '<span class="mg-ship__val">' + (free ? money(state.total) : from(state.total + cheap)) + '</span>' +
      '</div>' +
      '<p class="mg-ship__note">Tartalmazza az áfát. ' + codText() + '</p>' +
      '<button type="button" class="mg-ship__open" aria-haspopup="dialog">' +
        '<span>' + ICONS.truck + 'Szállítási módok és árak</span>' + ICONS.chevron +
      '</button>' +
      '<dialog class="mg-ship-sheet" aria-labelledby="MgShipSheetTitle">' +
        '<div class="mg-ship-sheet__inner">' +
          '<span class="mg-ship-sheet__handle" aria-hidden="true"></span>' +
          '<div class="mg-ship-sheet__head">' +
            '<h2 class="mg-ship-sheet__title" id="MgShipSheetTitle">Szállítási módok és árak</h2>' +
            '<button type="button" class="mg-ship-sheet__close" aria-label="Bezárás">' + ICONS.close + '</button>' +
          '</div>' +
          '<p class="mg-ship-sheet__sub">' + (free ? 'A módot a pénztárban választod.' : 'A módot a pénztárban választod. Becsült végösszeg a mostani kosárral.') + '</p>' +
          '<ul class="mg-ship-sheet__list">' + rows + '</ul>' +
          '<p class="mg-ship-sheet__foot">' + foot + '</p>' +
        '</div>' +
      '</dialog>';
  }

  var suppressEscapeUntil = 0;
  window.addEventListener('keyup', function (event) {
    if ((event.key === 'Escape' || event.key === 'Esc') && Date.now() < suppressEscapeUntil) {
      event.stopPropagation();
    }
  }, true);

  function bindSheet(block) {
    var openButton = block.querySelector('.mg-ship__open');
    var dialog = block.querySelector('.mg-ship-sheet');
    if (!openButton || !dialog) return;
    openButton.addEventListener('click', function () {
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    });
    function close() {
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
      suppressEscapeUntil = Date.now() + 400;
      try { openButton.focus({ preventScroll: true }); } catch (e) {}
    }
    block.querySelector('.mg-ship-sheet__close').addEventListener('click', close);
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) close();
    });
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      close();
    });
    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' || event.key === 'Esc') event.stopPropagation();
    });
  }

  function renderDrawer() {
    var footer = document.querySelector('#mini-cart .mini-cart__footer');
    if (!footer) return;
    var old = footer.querySelector('.mg-ship--drawer');
    if (old) old.remove();
    if (!state.count || state.total === null) {
      footer.classList.remove('mg-ship-on');
      return;
    }
    var block = document.createElement('div');
    block.className = 'mg-ship mg-ship--drawer';
    block.innerHTML = drawerHtml();
    var subtotal = footer.querySelector('.subtotal');
    if (subtotal) {
      subtotal.insertAdjacentElement('afterend', block);
    } else {
      footer.insertBefore(block, footer.querySelector('.button-container'));
    }
    footer.classList.add('mg-ship-on');
    bindSheet(block);
  }

  function ensureDrawer() {
    var footer = document.querySelector('#mini-cart .mini-cart__footer');
    if (!footer || footer.querySelector('.mg-ship--drawer')) return;
    // A kosárfiók újrarajzolása kosárváltozást jelent: friss adat kell.
    fetchCart().then(renderDrawer);
  }

  /* ---------- Kosároldal („B”) ---------- */
  function groupHtml(type, withTitle) {
    var free = isFree();
    var lines = methodsOf(type).map(function (m) {
      var price = free ? '<s>' + money(m.price) + '</s>' : money(m.price);
      return '<div class="mg-pb__line"><span>' + escapeHtml(m.name) + '</span><span>' + price + '</span></div>';
    }).join('');
    var head = free
      ? '<div class="mg-pb__from mg-ship__free">Ingyenes</div>'
      : '<div class="mg-pb__from">' + from(cheapest(type)) + '</div>';
    var title = withTitle ? '<div class="mg-pb__group">' + (type === 'home' ? 'Házhozszállítás' : 'Csomagpont, csomagautomata') + '</div>' : '';
    return title + head + lines + '<div class="mg-pb__eta">Érkezés: ' + MG_CONFIG.eta + '</div>';
  }
  function footnote() {
    return isFree()
      ? codText()
      : codText() + ' ' + money(MG_CONFIG.threshold) + ' felett mindegyik ingyenes.';
  }
  function pickupRows() {
    return document.querySelectorAll('#MainContent .pp-provider-home-delivery-button, #MainContent .pp-provider-package-point-button');
  }

  function renderCartPage() {
    if (!isCartPage || state.total === null) return;
    var key = isFree() ? 'free' : 'paid';
    var rows = pickupRows();
    var target = null;

    Array.prototype.forEach.call(rows, function (row) {
      var type = row.classList.contains('pp-provider-home-delivery-button') ? 'home' : 'point';
      var box = row.querySelector('.mg-pb');
      if (box && box.getAttribute('data-k') === key) return;
      if (box) box.remove();
      var outer = row.firstElementChild;
      var textBox = outer && outer.children[1] ? outer.children[1] : row;
      box = document.createElement('div');
      box.className = 'mg-pb';
      box.setAttribute('data-k', key);
      box.innerHTML = groupHtml(type, false);
      textBox.appendChild(box);
      row.classList.add('mg-pb-row');
    });

    if (rows.length) {
      var app = rows[0].closest('#mapApp');
      target = app;
      if (app && app.parentElement) {
        var note = app.parentElement.querySelector(':scope > .mg-pb-note');
        if (!note) {
          note = document.createElement('p');
          note.className = 'mg-pb-note';
          app.insertAdjacentElement('afterend', note);
        }
        if (note.textContent !== footnote()) note.textContent = footnote();
      }
      var standalone = document.querySelector('.mg-ship--standalone');
      if (standalone) standalone.remove();
    } else if (fallbackAllowed) {
      target = renderStandalone(key);
    }

    renderJump(target || document.querySelector('.mg-ship--standalone'));
  }

  function renderStandalone(key) {
    var block = document.querySelector('.mg-ship--standalone');
    if (block && block.getAttribute('data-k') === key) return block;
    if (!block) {
      block = document.createElement('section');
      block.className = 'mg-ship--standalone page-width';
      block.setAttribute('aria-label', 'Szállítási díjak');
      var anchor = document.getElementById('cart-free-shipping');
      var section = anchor ? anchor.closest('.shopify-section') : null;
      if (section) {
        section.insertAdjacentElement('afterend', block);
      } else {
        var footerSection = document.getElementById('main-cart-footer');
        if (!footerSection) return null;
        footerSection.insertAdjacentElement('beforebegin', block);
      }
    }
    block.setAttribute('data-k', key);
    block.innerHTML = '<h2>Szállítási díjak</h2>' +
      '<div class="mg-pb">' + groupHtml('point', true) + '</div>' +
      '<div class="mg-pb">' + groupHtml('home', true) + '</div>' +
      '<p class="mg-pb-note">' + footnote() + '</p>';
    return block;
  }

  function renderJump(target) {
    var holder = document.getElementById('cart-free-shipping');
    if (!holder || !target) return;
    var text = isFree() ? 'Ingyenes szállítás minden módnál' : 'Szállítás ' + from(cheapest()) + ' – díjak lent';
    var link = holder.querySelector('.mg-ship-jump');
    if (!link) {
      link = document.createElement('a');
      link.href = '#';
      link.className = 'mg-ship-jump';
      link.addEventListener('click', function (event) {
        event.preventDefault();
        var goal = document.querySelector('#MainContent .pp-provider-home-delivery-button');
        goal = goal ? goal.closest('#mapApp') : document.querySelector('.mg-ship--standalone');
        if (goal) goal.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      var wrap = holder.querySelector('.free-shipping') || holder;
      wrap.appendChild(link);
    }
    var html = ICONS.truck + '<span>' + text + '</span>';
    if (link.innerHTML !== html) link.innerHTML = html;
  }

  /* ---------- Frissítés ---------- */
  var fallbackAllowed = false;
  var timer = null;
  function schedule(fn) {
    clearTimeout(timer);
    timer = setTimeout(fn, 60);
  }
  function refreshAll() {
    fetchCart().then(function () {
      renderDrawer();
      renderCartPage();
    });
  }

  function init() {
    var miniCart = document.getElementById('mini-cart');
    if (miniCart && 'MutationObserver' in window) {
      new MutationObserver(function () { schedule(ensureDrawer); }).observe(miniCart, { childList: true, subtree: true });
    }
    ensureDrawer();

    if (isCartPage) {
      var main = document.getElementById('MainContent');
      if (main && 'MutationObserver' in window) {
        new MutationObserver(function () { schedule(renderCartPage); }).observe(main, { childList: true, subtree: true });
      }
      setTimeout(function () {
        fallbackAllowed = true;
        renderCartPage();
      }, 5000);
      fetchCart().then(renderCartPage);
    }

    document.addEventListener('cart:updated', refreshAll);
    document.addEventListener('cartdrawer:opened', ensureDrawer);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshAll);
    }
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) refreshAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();